import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Filter = "all" | "hired" | "available" | "fired";
export type View   = "rh" | "office" | "demands" | "meeting" | "meetings" | "clients" | "about" | "log" | "gallery" | "briefing" | "social" | "ops" | "library" | "funnel";
export type AgendaMode = "ata" | "conselho";

export interface SavedMeeting {
  id: string;
  title: string;
  topic: string;
  mode: AgendaMode;
  picks: string[];
  agenda: string[];
  createdAt: number;
}

interface UIState {
  filter: Filter;
  view: View;
  search: string;
  meetingPicks: string[];
  agendaMode: AgendaMode;
  savedMeetings: SavedMeeting[];
  setFilter: (f: Filter) => void;
  setView: (v: View) => void;
  setSearch: (s: string) => void;
  setAgendaMode: (m: AgendaMode) => void;
  toggleMeeting: (id: string) => void;
  clearMeeting: () => void;
  saveMeeting: (m: Omit<SavedMeeting, "id" | "createdAt">) => void;
  deleteMeeting: (id: string) => void;
}

const uid = () => Math.random().toString(36).slice(2, 10);

export const useUI = create<UIState>()(
  persist(
    (set) => ({
      filter: "all",
      view: "rh",
      search: "",
      meetingPicks: [],
      agendaMode: "ata",
      savedMeetings: [],
      setFilter: (filter) => set({ filter }),
      setView:   (view)   => set({ view }),
      setSearch: (search) => set({ search }),
      setAgendaMode: (agendaMode) => set({ agendaMode }),
      toggleMeeting: (id) => set(s => ({
        meetingPicks: s.meetingPicks.includes(id)
          ? s.meetingPicks.filter(x => x !== id)
          : [...s.meetingPicks, id]
      })),
      clearMeeting: () => set({ meetingPicks: [] }),
      saveMeeting: (m) => set(s => ({
        savedMeetings: [{ ...m, id: uid(), createdAt: Date.now() }, ...s.savedMeetings].slice(0, 100)
      })),
      deleteMeeting: (id) => set(s => ({
        savedMeetings: s.savedMeetings.filter(m => m.id !== id)
      }))
    }),
    {
      name: "agencia-vpc-ui-v2",
      partialize: (s) => ({ savedMeetings: s.savedMeetings, agendaMode: s.agendaMode })
    }
  )
);
